import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor } from '../../../util/theme';

// import styled components
import { Grid } from '../../styled';

const FooterContainer = styled(Grid)`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: ${getBreakpoint('md')}) {
    flex-direction: row;
  }

  @media (min-width: ${getBreakpoint('lg')}) {
    padding: 0 50px;
  }

  p,
  a {
    font-size: 1.4rem;
  }

  p {
    color: ${getColor('primaryBlue')};

    margin: 0;
  }
`;

export default FooterContainer;
